import { styled } from "styled-components";
import { IArticle } from "../components/HelpCenter.config";
import HelpCenterHeader from "../components/HelpCenterHeader";
import { useNavigate } from "react-router-dom";
import { useDocumentTitle } from "@dataone/lib";

interface HelpCenterArticlesPageProps {
  title: string;
  articles: IArticle[];
}

const HelpCenterArticlesPage = ({
  title,
  articles,
}: HelpCenterArticlesPageProps) => {
  const navigate = useNavigate();
  const handleViewArticle = (path: string) => {
    navigate(path);
  };
  useDocumentTitle("OneGate | Help Center");
  return (
    <StyledHelpCenterArticlesPage>
      <HelpCenterHeader secondTitle={title} />
      <Content>
        <Title>{title}</Title>
        <p>{articles.length} Articles</p>
        <ArticleList>
          {articles.map((article, index) => {
            return (
              <div key={index}>
                <StyledLink onClick={() => handleViewArticle(article.path!)}>
                  {article.title}
                </StyledLink>
              </div>
            );
          })}
        </ArticleList>
      </Content>
    </StyledHelpCenterArticlesPage>
  );
};

export default HelpCenterArticlesPage;

const StyledHelpCenterArticlesPage = styled.div`
  padding: 5px 10px;
`;
const Title = styled.h1`
  color: #4974f6;
`;
const Content = styled.div`
  padding: 30px 45px;
`;
const ArticleList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 45px;
`;
const StyledLink = styled.p`
  color: #4974f6;
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    opacity: 0.8;
  }
`;
